import { useEffect, useState } from 'react'
import { usePutIdsTransmissionsRequesterValidating } from '@toktokdoctech/tokapi-client'
import { useParams } from 'react-router-dom'
import { RequesterEmailValidationVariant } from './props'
import Loader from '../../Common/Loader/Loader'
import { RequesterEmailValidationDisplay } from './RequesterEmailValidationDisplay'
import { SingleCenteredCardLayout } from '../../../layouts/SingleCenteredCardLayout/SingleCenteredCardLayout'

export const RequesterEmailValidationContainer = () => {
    const { transmissionId, token, decision } = useParams()
    const [validationStatus, setValidationStatus] = useState<RequesterEmailValidationVariant | null>(null)

    const { mutate: notifyDecision } = usePutIdsTransmissionsRequesterValidating({
        mutation: {
            onSuccess: () => setValidationStatus('success'),
            onError: (error: any) => {
                const status = error?.status ?? error?.response?.status ?? null
                if (status === 410) setValidationStatus('outdated')
                else if (status === 404) setValidationStatus('invalid')
                else setValidationStatus('error')
            },
        },
    })

    useEffect(() => {
        if (token && decision !== undefined && transmissionId)
            notifyDecision({ data: { transmissionId, token, doesUserAgree: decision === 'accept' } })
    }, [token, decision, transmissionId, notifyDecision])

    if (validationStatus === null)
        return (
            <SingleCenteredCardLayout>
                <Loader />
            </SingleCenteredCardLayout>
        )
    return <RequesterEmailValidationDisplay variant={validationStatus} />
}
